<template>
  <div class="d-flex flex-column flex-sm-row">
    <e-select
      v-model="filters.roomCategory"
      :items="activeTariffPlacingVariants || []"
      item-title="roomCategory.name[0].value"
      item-value="roomCategory.cid"
      label="Категория номера"
      class="placing-variants-filters__input"
      clearable
    />
    <e-select
      v-model="filters.touristType"
      :items="touristsTypesFilterItems"
      label="Тип туриста"
      class="placing-variants-filters__input"
      clearable
    />
  </div>

  <div class="d-flex">
    <e-checkbox
      v-model="filters.onlyConflicted"
      label="Только конфликтные"
      class="placing-variants-filters__checkbox"
    />
    <div class="placing-variants-filters__badge ml-1 mr-1" />
    <help-tooltip class="mr-2">
      Конфликтные варианты размещения - это варианты размещения связанные с удаленными сущностями тарифного плана,
      например относящиеся к удаленной из тарифного плана категории номеров или удаленному типу туриста.
    </help-tooltip>
  </div>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import type { PlacingVariantsFilter } from '@/parts/tariffs/types/tariffs';
import { ECheckbox, ESelect, HelpTooltip } from '@/core/components/ui';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';
import { rangeTouristTypesString } from '@/parts/tariffs/utils/tariffs';

const filters = defineModel<PlacingVariantsFilter>({ required: true });

const { activeTariffPlacingVariants, activeTariff } = useTariffsStore();

const touristsTypesFilterItems = toRef(
  () =>
    activeTariff.value?.baseSettings?.ageSettings?.categories?.values.map((type) => ({
      title: rangeTouristTypesString(type),
    })) || [],
);
</script>

<style scoped lang="scss">
.placing-variants-filters {
  &__input {
    width: 280px;
    max-width: 280px;
    margin-right: $gap-4;

    @include md-and-down {
      width: 100%;
      max-width: calc((100% - $gap-4) / 2);
      margin-right: 0;
      margin-bottom: 24px;
      &:first-of-type {
        margin-right: 16px;
      }
    }

    @include sm-and-down {
      margin-bottom: 16px;
    }
    @include xs {
      max-width: 100%;
    }
  }

  &__checkbox {
    min-width: 189px;
  }

  &__badge {
    width: 8px;
    min-width: 8px;
    height: 8px;
    margin-bottom: 12px;
    margin-left: $gap-1;

    background-color: $alert-color;
    border-radius: 50%;
  }
}
</style>
